import * as z from 'zod/mini';
import { identifierSchema } from '../naming.ts';
import { idSchema, nameSchema, timestampSchema } from './common.ts';

export const clientSchema = z.object({
  id: idSchema,
  name: z.string(),
  /** Short path segment; blank only in a cache made before migration 0051. */
  identifier: z._default(z.string(), ''),
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
});
export type Client = z.infer<typeof clientSchema>;

export const clientInputSchema = z.object({
  name: nameSchema,
  identifier: z.optional(identifierSchema),
});
export type ClientInput = z.infer<typeof clientInputSchema>;

export const clientPatchSchema = z.partial(clientInputSchema);
export type ClientPatch = z.infer<typeof clientPatchSchema>;
